<template>
  <div class="container">
    <div class="grid justify-content-center">
      <div class="col-12 md:col-6">
        <div class="card text-center">
          <div>
            <router-link to="/">
              <img
                class=""
                src="images/logo.png"
                alt="logo"
                style="height: 56px"
              />
            </router-link>
          </div>
          <div class="text-xl font-bold text-green-600 mt-3 mb-2">
            {{ sentMsg }}
          </div>
          <div class="text-500">
            {{
              $t(
                "please_verify_your_email_address_by_following_the_link_in_your_mailbox"
              )
            }}
          </div>
          <hr />
          <div class="text-center">
            <Button
              :label="$t('resend_email')"
              @click="resend()"
              icon="pi pi-envelope"
              :loading="loading"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
export default {
  props: {},
  mixins: [PageMixin],
  data: function () {
    return {
      loading: false,
      sentMsg: "Email verification link sent to your mailbox",
    };
  },
  methods: {
    resend() {
      let url = "auth/resendverifyemail";
      this.loading = true;
      let formData = {
        token: this.$route.query.token,
      };
      this.$api.post(url, formData).then(
        (response) => {
          this.loading = false;
          this.sentMsg = response.data;
        },
        (response) => {
          this.loading = false;
          this.showPageRequestError(response);
        }
      );
    },
  },
};
</script>
